import { store } from "@betacrew/jars-flux";
import { componentKey, setUploadedFile, setValidationStatus } from "./BulkUploadSlice";
import { setLoadingState } from "../AddRecipientSlice";
import { all, put, takeLatest, takeLeading, call, select } from "redux-saga/effects";
import { PAGE_STATE } from "../../../constants/constants";
import { TOASTER_VARIANT } from "../../../../components/toast/constants";
import { addNotifications } from "../../../toaster/ToasterPortalSlice";
import RecipientDataService from "../../../../../services/RecipientDataService";
import General from "../../../../../libs/utility/General";
import { ADD_RECIPIENT_LOADING_STATES } from "../constant";


export const { getTemplate, uploadSheet, validateSheetRecords, downloadErroReport } = {

    getTemplate: (payload) => {
        return {
            type: "RECIPIENT/GET_TEMPLATE_NEW",
            payload
        }
    },

    uploadSheet: (payload) => {
        return {
            type: "RECIPIENT/UPLOAD_SHEET_NEW",
            payload
        }
    },

    validateSheetRecords: (payload) => {
        return {
            type: "RECIPIENT/VALIDATE_SHEET_RECORDS_NEW",
            payload
        }
    },

    downloadErroReport: (payload) => {
        return {
            type: "RECIPIENT/DOWNLOAD_ERROR_REPORT_NEW",
            payload
        }
    }
}


function* getTemplateAsync(action) {

    try {
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.GET_TEMPLATE_LOADING }))

        const response = yield RecipientDataService.getTemplate();

        if (response?.data.Status) {
            const { Base64, Name } = response?.data?.Data;
            General.downloadFile(Base64, Name);
            yield put(addNotifications({ heading: "Template Downloaded", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Something went wrong, failed to download the template", message: response?.data?.Message }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Failed to download the template", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.GET_TEMPLATE_READY }))
    }

}

function* uploadSheetAsync(action) {

    try {
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.BULK_UPLOAD_SHEET_LOADING }))
        const uploadedFile = action.payload;

        const formData = new FormData();
        formData.append("files", uploadedFile);

        const response = yield RecipientDataService.uploadSheet(formData);

        if (response?.data.Status) {
            yield put(addNotifications({ heading: "File Uploaded Successfully", message: response?.data?.Message, variant: TOASTER_VARIANT.SUCCESS }));
        } else {
            yield put(addNotifications({ heading: "Something went wrong, file not uploaded successfully", message: response?.data?.Message }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Failed to upload a file", message: error?.response?.data?.Message }));
    } finally {
        yield put(setLoadingState({ state:  ADD_RECIPIENT_LOADING_STATES.BULK_UPLOAD_SHEET_READY }))
    }

}


function* validateSheetRecordsAsync(action) {

    try {
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.VALIDATE_BULK_UPLOAD_SHEET_RECORD_LOADING }))

        const { payerId } = action.payload
        const params = {
            payerId: payerId
        }

        const response = yield RecipientDataService.validateSheetRecords(params);
        const { Status, Message, Data } = response?.data;

        const totalRecord = isNaN(Data) ? General.convertObjStringToObject(Data)?.total : Data

        if (Status) {
            yield put(setValidationStatus({
                successfullyAddedPayers: parseInt(Data),
                payersWithErrors: 0,
                success: Status ? true : false,
                message: Message
            }))

        } else {
            const { errorCount } = General.convertObjStringToObject(Data)
            const status = Status ? true : false;

            if (errorCount < 10) {
                yield put(addNotifications({ heading: "Something went wrong, Validation failed", message: Message }));
                yield put(setValidationStatus({ successfullyAddedPayers: parseInt(totalRecord), payersWithErrors: errorCount, success: status, isTaxIdError: false }))
            } else {
                yield put(setValidationStatus({ successfullyAddedPayers: parseInt(totalRecord), payersWithErrors: errorCount, success: status, isTaxIdError: false }))
            }
        }

    } catch (error) {
        const { Status, Message, Data } = error.response?.data;

        const totalRecord = isNaN(Data) ? General.convertObjStringToObject(Data)?.total : Data
        const { errorCount } = General.convertObjStringToObject(Data)
        
        const status = Status ? true : false;

        /* In case of missing Payer Tax ID, we don't get the count of Successfully Added Payers and Payer With Errors. 
           In this case users won't be allowed to download the error report. */
        if (errorCount === 0) {
            yield put(setValidationStatus({ successfullyAddedPayers: 0, payersWithErrors: errorCount, success: status, isTaxIdError: true }))
        } else {
            yield put(setValidationStatus({ successfullyAddedPayers: parseInt(totalRecord), payersWithErrors: errorCount, success: status, isTaxIdError: false }))
        }

        yield put(addNotifications({ heading: "Validation Failed", message: Message }));
    } finally {
        yield put(setUploadedFile(null))
        yield put(setLoadingState({ state: ADD_RECIPIENT_LOADING_STATES.VALIDATE_BULK_UPLOAD_SHEET_RECORD_READY }))
    }

}

function* downloadErroReportAsync(action) {

    try {
        const response = yield RecipientDataService.getErrorReport();

        if (response?.data.Status) {
            const { Base64, Name } = response?.data?.Data;
            General.downloadFile(Base64, Name)
        } else {
            yield put(addNotifications({ heading: "Something went wrong, failed to download an error report", message: response?.data?.Message }));
        }

    } catch (error) {
        yield put(addNotifications({ heading: "Failed to donwload an error report", message: error?.response?.data?.Message }));
    }

}

function* rootSaga() {
    yield all([
        takeLatest(getTemplate().type, getTemplateAsync),
        takeLatest(uploadSheet().type, uploadSheetAsync),
        takeLeading(validateSheetRecords().type, validateSheetRecordsAsync),
        takeLeading(downloadErroReport().type, downloadErroReportAsync),
    ]);
}

store.sagaManager.addSaga(componentKey, rootSaga);